var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"serial_input"},[_c('div',{key:_vm.i,staticClass:"slice"},[_vm._t("default",function(){return [_vm._v(" No template defined. ")]},{"i":_vm.i,"iterations":_vm.iterations,"record":(variable, value) =>
          _vm.$magpie.measurements[variable] &&
          _vm.$magpie.measurements[variable].length
            ? _vm.$magpie.measurements[variable].push(value)
            : (_vm.$magpie.measurements[variable] = [value]),"next":() => _vm.i++})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }